import React from 'react';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import config from 'config';
import styles from './DonateButton.scss';
import {
  ExperimentKeys,
  experiments as experimentConstants,
} from 'src/constants/experiments';
import { encodeBase64 } from 'src/helpers/base64';
import { Trans } from 'react-i18next';
import { useDonatePopup } from 'src/components/DonatePopup/DonatePopupContext';

interface Props {
  isActive: boolean;
  name: string;
  pageSection: string;
  donate: (options: { pageSection: string }) => void;
  experiments?: ExperimentKeys[];
  successType?: string;
}

export function DonateButton({
  isActive,
  name,
  pageSection,
  donate,
  // Pass all the experiments by default
  experiments = Object.values(experimentConstants),
  successType = 'StaticDonateButtonClick',
}: Props) {
  const { showCheckoutPopup } = useDonatePopup();
  const buttonClass = classNames('jg-btn', {
    'is-disabled': !isActive,
  });

  const buildQueryString = (showEmbeddedCheckout?: boolean) => {
    const urlParams = new URLSearchParams();

    if (pageSection) {
      urlParams.append('pageSection', pageSection);
    }

    const trimmedSuccessType = successType.trim();
    const trimmedExperiments = experiments
      .map(e => e.trim())
      .filter(e => e !== '');

    if (
      trimmedExperiments &&
      trimmedExperiments.length > 0 &&
      trimmedSuccessType
    ) {
      urlParams.append(
        'experiments',
        encodeBase64(trimmedExperiments.join(','))
      );
      urlParams.append('successType', encodeBase64(trimmedSuccessType));
      if (showEmbeddedCheckout) {
        urlParams.append('checkoutMode', 'Headless');
      }
    }

    return urlParams.toString() ? `?${urlParams.toString()}` : '';
  };

  const donateLink = isActive
    ? `${config.CROWDFUNDING_BASE_URI}/${name}/donate${buildQueryString()}`
    : null;

  const onClickDonate = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (
      config.FEATURE.EMBEDDED_CHECKOUT ||
      urlParams.get('popupCheckout') === 'true'
    ) {
      event.preventDefault();
      const modalDonateLink = `${
        config.CROWDFUNDING_BASE_URI
      }/${name}/donate${buildQueryString(true)}`;
      showCheckoutPopup(modalDonateLink);
    }
    donate({ pageSection });
  };

  return (
    <a
      data-marker="donate-button"
      onClick={onClickDonate}
      href={donateLink}
      className={buttonClass}
      styleName="fixed-donate-button"
    >
      <Trans i18nKey="Common.Donate">Give Now</Trans>
    </a>
  );
}

export default CSSModules(DonateButton, styles);



// WEBPACK FOOTER //
// ./src/components/Page/DonateButton.tsx